export function Spinner({className, testId}: {className?: string; testId?: string}) {
    return (
        <div
            // w-4 h-4
            className={className}
        >
            <svg
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full animate-spin"
                data-testid={testId}
            >
                <circle
                    cx="8"
                    cy="8"
                    r="7"
                    style={{
                        fill: "none",
                        stroke: "currentcolor",
                        strokeWidth: 1.5,
                        strokeDasharray: 60,
                        strokeDashoffset: 50,
                        // strokeLinecap: "round",
                    }}
                />
            </svg>
        </div>
    );
}
